/* eslint-disable jsx-a11y/heading-has-content */
import React from "react";

import styles from "./h1.module.scss"

const H1 = (props) => {
  if (props.slideUp) {
    return (
      <div
        data-sal="slide-up"
        data-sal-delay="100"
        data-sal-duration="1000"
        data-sal-easing="ease"
      >
        <h1 {...props} className={`${styles.root} ${props.className} ${styles[props.color]}`} />
      </div>
    )
  }
  return (
    <h1 {...props} className={`${styles.root} ${props.className} ${styles[props.color]}`} />
  )
}

H1.defaultProps = {
  className: '',
  color: 'primaryGreen',
  slideUp: false,
}

export default H1;
